import Vue from 'vue'
import router from '@/router/router'

export function errorSubmitOrderMsg(data) {
  if (data === -2) {
    return "提交失败，有进行中流程"
  } else if (data === -3) {
    return "提交失败，订单状态不对"
  } else if (data === -4) {
    return "提交失败，终稿未生成"
  }
  return "提交失败"
}


export function alertCommon(data, successMsg, errorMsg) {
  if (data > 0) {
    alertSuccessMsg(successMsg)
  } else {
    alertErroMsg(errorMsg)
  }
}


export function alertSuccessMsg(msg) {
  Vue.prototype.$message.success({
    message: msg || "提交成功", duration: 1500, onClose: () => {
      router.replace({
        path: '/refresh'
      })
    }
  });
}

export function alertErroMsg(msg) {
  Vue.prototype.$message.error({
    message: msg || "提交失败", duration: 1500, onClose: () => {
      router.replace({
        path: '/refresh'
      })
    }
  });
}





export function alertCommonWithFn(data, successMsg, errorMsg,fn) {
  if (data > 0) {
    alertSuccessMsgWithFn(successMsg,fn)
  } else {
    alertErroMsgWithFn(errorMsg,fn)
  }
}


export function alertSuccessMsgWithFn(msg,fn) {
  Vue.prototype.$message.success({
    message: msg || "提交成功", duration: 1500, onClose: () => {
      router.replace({
        path: '/refresh'
      })
    }
  });
}

export function alertErroMsgWithFn(msg,fn) {
  Vue.prototype.$message.error({
    message: msg || "提交失败", duration: 1500, onClose: () => {
      router.replace({
        path: '/refresh'
      })
    }
  });
}


